import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async get(id) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/avis_rpo/" + id;
    const response = await axios.get(url);
    return response.data;
  },
  async getCR(id) {
    const url = this.getCRURL(id);
    const response = await axios.get(url, { responseType: "blob" });
    return response.data;
  },
  getCRURL(id) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/avis_rpo/" +
      id +
      "/compte_rendu_visite"
    );
  },
  async new(avis_rpo) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/avis_rpos";
    const response = await axios.post(url, avis_rpo);
    return response.data;
  },
  async update(id, avis_rpo) {
    const url = process.env.VUE_APP_BACKEND_API_URL + "/api/avis_rpo/" + id;
    const response = await axios.put(url, avis_rpo);
    return response.data;
  },
  async deleteVisite(id) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL + "/api/avis_rpo/" + id + "/visite";
    const response = await axios.delete(url);
    return response.data;
  },
  async uploadCR(id, compteRendu) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL +
      "/api/avis_rpo/" +
      id +
      "/compte_rendu_visite";
    let fd = new FormData();
    fd.append("file", compteRendu);
    const response = await axios.put(url, fd);
    return response.data;
  }
};
